import FormInputText from '@components/forms/FormInputText';
import { Grid2 } from '@mui/material';

export default function WrestlerNameForm() {
    return (
        <>
            <Grid2 size={{ sm: 12, md: 6 }} alignSelf={'center'}>
                <FormInputText name="firstName" label="First Name" />
            </Grid2>
            <Grid2 size={{ sm: 12, md: 6 }} alignSelf={'center'}>
                <FormInputText name="lastName" label="Last Name" />
            </Grid2>
        </>
    );
}
